import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import axios from 'axios';

import Headline from 'ui/Headline';
import SidebarTemplate from 'templates/SidebarTemplate/SidebarTemplate';
import { BoxImage } from 'components/BoxImage';
import { devices } from 'styles/devices';
import Loader from 'components/Loader';
import { FormattedMessage } from 'react-intl';

const ListResultsView = () => {
   const [results, setResults] = useState([]);
   const history = useNavigate();

   useEffect(() => {
      const state = history?.location?.state;

      if (state?.category?.length) {
         axios
            .get(`/wp/v2/posts?categories=${state?.category[1]}&per_page=15`)
            .then(({ data }) =>
               data.map((post) => {
                  const mediaUrl = post?._links['wp:featuredmedia']?.[0]?.href.replace(
                     'https://info-cms.konsport.com/wp-json',
                     ''
                  );

                  return { ...post, mediaUrl };
               })
            )
            .then((posts) => {
               posts.map((post) => {
                  axios
                     .get(post.mediaUrl)
                     .then(({ data }) => data?.source_url)
                     .then((image) => {
                        setResults((prev) => [
                           ...prev,
                           {
                              id: post?.id,
                              headline: post?.title?.rendered,
                              path: `/katalog/produkty/${post?.id}`,
                              image
                           }
                        ]);
                     });
               });
            });
      } else if (state?.tag) {
         axios
            .get(`/wp/v2/posts?tags=${state?.tag}&per_page=15`)
            .then(({ data }) =>
               data.map((post) => {
                  const mediaUrl = post?._links['wp:featuredmedia'][0]?.href.replace(
                     'https://info-cms.konsport.com/wp-json',
                     ''
                  );

                  return { ...post, mediaUrl };
               })
            )
            .then((posts) => {
               posts.map((post) => {
                  axios
                     .get(post.mediaUrl)
                     .then(({ data }) => data?.source_url)
                     .then((image) => {
                        setResults((prev) => [
                           ...prev,
                           {
                              id: post?.id,
                              headline: post?.title?.rendered,
                              path: `/katalog/produkty/${post?.id}`,
                              image
                           }
                        ]);
                     });
               });
            });
      } else {
         axios
            .get('/wp/v2/posts', {
               params: {
                  categories: 110
               }
            })
            .then(({ data }) =>
               data.map((post) => {
                  const mediaUrl =
                     post?._links &&
                     post?._links['wp:featuredmedia'] &&
                     post?._links['wp:featuredmedia'][0] &&
                     post?._links['wp:featuredmedia'][0]?.href?.replace(
                        'https://info-cms.konsport.com/wp-json',
                        ''
                     );

                  return { ...post, mediaUrl };
               })
            )
            .then((posts) => {
               posts.map((post) => {
                  const path = `${post?.id}`;
                  axios
                     .get(post.mediaUrl)
                     .then(({ data }) => data?.source_url)
                     .then((image) => {
                        setResults((prev) => [
                           ...prev,
                           {
                              id: post?.id,
                              headline: post?.title?.rendered,
                              path,
                              image
                           }
                        ]);
                     });
               });
            });
      }
   }, []);

   return (
      <SidebarTemplate navigation="product">
         <StyledHeadline size="XXL">
            {!!history?.location?.state?.tagName && (
               <>
                  <FormattedMessage id="PopularTags" /> {history?.location?.state?.tagName}
               </>
            )}
            {history?.location?.state?.category?.length && history?.location?.state?.category[0]}
         </StyledHeadline>
         {!results.length ? (
            <Loader />
         ) : (
            <Grid>
               {results?.map((result) => (
                  <BoxImage
                     key={Math.random()}
                     image={result.image}
                     headline={result.headline}
                     description={result.description}
                     path={result.path}
                  />
               ))}
            </Grid>
         )}
      </SidebarTemplate>
   );
};

const StyledHeadline = styled(Headline)`
   text-transform: capitalize;
`;

const Grid = styled.div`
   grid-template-columns: repeat(1, 1fr);
   grid-gap: 20px;
   margin-top: 20px;

   ${devices.mobileL} {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
   }

   ${devices.tabletXL} {
      margin-top: 30px;
   }

   ${devices.desktopHD} {
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 30px;
   }

   ${devices.desktopFHD} {
      grid-gap: 40px;
      margin-top: 40px;
   }
`;

export default ListResultsView;
